import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
const Button = ({
  size,
  color,
  children,
  onClick,
  isDisabled,
  isLoading
}) => {
  const cls = classNames('btn', {
    [`btn-${size}`]: size,
    'btn-primary': color === 'red',
    'btn-primary btn-link': color === 'white',
    loading: isLoading
  });
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: cls,
    onClick: onClick,
    disabled: isDisabled
  }, children);
};
Button.propTypes = {
  children: PropTypes.node,
  size: PropTypes.oneOf(['xs', 'sm']),
  color: PropTypes.oneOf(['red', 'white']),
  onClick: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  isLoading: PropTypes.bool
};
export default Button;